import React, { useState } from "react";
import supabase from "../utils/supabase";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { FcGoogle } from "react-icons/fc"; // Add this import

export default function SignIn() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    emailPhone: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setLoadingMessage("Signing In...");
    const newErrors = {};

    // Validation
    if (!formData.emailPhone.trim()) {
      newErrors.emailPhone = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailPhone.trim())) {
      newErrors.emailPhone = "Enter a valid email.";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: formData.emailPhone,
        password: formData.password,
      });

      if (error) {
        setLoading(false);
        setLoadingMessage("");
        alert("Invalid email or password. Please try again.");
      } else {
        setLoading(false);
        setLoadingMessage("");
        navigate("/dashboard");
      }
    } else {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setLoadingMessage("Connecting to Google...");
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `${window.location.origin}/dashboard`,
      },
    });
    if (error) {
      alert(error.message);
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-tr from-[#0072ff] to-[#003f7f]">
      <img src="/logo.png" alt="Logo" className="w-40 mx-auto" />

      {loading && (
        <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-black bg-opacity-50">
          <HashLoader color="#0072ff" size={50} />
          <p className="text-white mt-4">{loadingMessage}</p>
        </div>
      )}
      <div className="bg-white/10 p-8 rounded-lg shadow-2xl w-4/5 max-w-sm mx-4 backdrop-blur-xl">
        <h2 className="text-2xl font-bold text-white text-center mb-6">
          Sign In
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <input
              type="text"
              id="emailPhone"
              value={formData.emailPhone}
              onChange={handleInputChange}
              className={`w-full p-3 bg-transparent text-white border-b ${
                errors.emailPhone ? "border-red-500" : "border-white/50"
              } focus:border-blue-300 focus:outline-none placeholder-gray-300`}
              placeholder="Email"
              required
            />
            {errors.emailPhone && (
              <p className="text-red-500 text-sm mt-1">{errors.emailPhone}</p>
            )}
          </div>

          <div className="mb-6">
            <input
              type="password"
              id="password"
              value={formData.password}
              onChange={handleInputChange}
              className={`w-full p-3 bg-transparent text-white border-b ${
                errors.password ? "border-red-500" : "border-white/50"
              } focus:border-blue-300 focus:outline-none placeholder-gray-300`}
              placeholder="Password"
              required
            />
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password}</p>
            )}
          </div>

          <button
            type="submit"
            className="w-full bg-blue-500 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-600 transition-colors"
          >
            Sign In
          </button>
        </form>

        {/* Add divider and Google button */}
        <div className="flex items-center my-4">
          <div className="flex-1 border-t border-white/30"></div>
          <span className="px-3 text-white/70 text-sm">OR</span>
          <div className="flex-1 border-t border-white/30"></div>
        </div>

        <button
          onClick={handleGoogleSignIn}
          className="w-full bg-white text-gray-700 font-bold py-3 px-4 rounded-lg hover:bg-gray-100 transition-colors flex items-center justify-center gap-2 mb-4"
        >
          <FcGoogle className="text-xl" />
          Sign in with Google
        </button>

        <p className="text-sm text-center text-gray-300 mt-4">
          Don't have an account?{" "}
          <a
            href="/signup"
            className="text-blue-300 hover:underline transition-colors"
          >
            Sign Up
          </a>
        </p>
      </div>
    </div>
  );
}
